import React, { useEffect } from 'react';
import { TimelineMax, Back, Linear } from 'gsap';
import style from './style.module.scss';
import ButtonPrimary from '../../ButtonPrimary';
import BeachBackDrop from '../../../images/landing_page/beach_scene_02.png';
import PalmTreeLeft from '../../../images/landing_page/palm_tree_01.png';
import PalmTreeRight from '../../../images/landing_page/palm_tree_02.png';
import BeachBall from '../../../images/landing_page/beach-ball.png';
import BimboEatingCookie from '../../../images/landing_page/bimbo_eating_cookie.png';
import BimboLogo from '../../../images/bimbo_logo_landing_page/bimbo_logo_crop.png';
import Sun from '../../../images/landing_page/sun_shine.png';
import Cloud2 from '../../../images/landing_page/cloud_02.png';
import 'react-responsive-carousel/lib/styles/carousel.css';
import 'react-responsive-carousel/lib/styles/main.css';
import '../../globalStyles.css';
const MultiLayerBimboArt = (props) => {

  let beachBallRef = null;
  let sunRef = null;
  let palmTreeLeft = null;
  let cloud2Ref = null;

  useEffect(() => {
    let BallTimeline = new TimelineMax({ delay: 2, repeat: -1, repeatDelay: 4 })
    BallTimeline.to(beachBallRef, 0.3, { y: -30, ease: Back.easeIn })
    BallTimeline.to(beachBallRef, 0.2, { y: 0, ease: Back.easeIn })
    BallTimeline.to(beachBallRef, 0.2, { y: -15, ease: Back.easeIn })
    BallTimeline.to(beachBallRef, 0.1, { y: 0, ease: Back.easeIn })
    BallTimeline.to(beachBallRef, 0.7, { x: +15, rotation: 20, delay: 2 })
    BallTimeline.to(beachBallRef, 0.7, { x: -8, rotation: -15 })
    BallTimeline.to(beachBallRef, 1, { x: 0, rotation: 0 })
    BallTimeline.play()

    let SunTimeline = new TimelineMax({ repeat: -1 });
    SunTimeline.to(sunRef, 1, { scale: 1.1, ease: Linear.easeNone })
    SunTimeline.to(sunRef, 1, { scale: 1.0, ease: Linear.easeNone })
    SunTimeline.play()

    let SunRotateTimeline = new TimelineMax({ repeat: -1 });
    SunRotateTimeline.to(sunRef, 80, { rotation: 360 })
    SunRotateTimeline.play()

    let PalmTreeLeftTimeline = new TimelineMax({ delay: 3, repeat: -1, repeatDelay: 0 })
    PalmTreeLeftTimeline.to(palmTreeLeft, 1, { rotation: 0.5, transformOrigin: "center bottom" })
    PalmTreeLeftTimeline.to(palmTreeLeft, 1, { rotation: -0.5, transformOrigin: "center bottom" })
    PalmTreeLeftTimeline.to(palmTreeLeft, 1, { rotation: 0, transformOrigin: "center bottom" })
    PalmTreeLeftTimeline.play()

    let cloud2TimelineY = new TimelineMax({ delay: 0, repeat: -1, repeatDelay: 0 })
    cloud2TimelineY.to(cloud2Ref, 1, { y: 5 });
    cloud2TimelineY.to(cloud2Ref, 1, { y: 0 })
    cloud2TimelineY.play()

    let cloud2TimelineX = new TimelineMax({ delay: 0, repeat: -1, repeatDelay: 0 })
    cloud2TimelineX.to(cloud2Ref, 8, { x: -60 })
    cloud2TimelineX.to(cloud2Ref, 8, { x: 0 })
    cloud2TimelineX.play()

    const clearTimelines = () => {
      BallTimeline.clear();
      SunTimeline.clear();
      SunRotateTimeline.clear();
      PalmTreeLeftTimeline.clear();
      cloud2TimelineX.clear();
      cloud2TimelineY.clear();
    }
    return clearTimelines;
  }, [])

  return (
    <>
      <div className={style.sectionContainer}>
        <div className={style.actionWrapper}>
          <ButtonPrimary label="Learn More" type="lightBlue" size="medium" />
        </div>
        <img ref={e => sunRef = e} src={Sun} className={style.sun} />
        <img ref={e => cloud2Ref = e} src={Cloud2} className={style.cloud2} />
        <img src={BimboLogo} className={style.bimboLogo} />
        <img src={BimboEatingCookie} className={style.bimboEatingCookie} />
        <img ref={e => beachBallRef = e} src={BeachBall} className={style.beachBall} />
        <img ref={e => palmTreeLeft = e} src={PalmTreeLeft} className={style.leftPalmTree} />
        <img src={PalmTreeRight} className={style.rightPalmTree} />
        <img src={BeachBackDrop} className={style.beachBackdrop} />
      </div>
    </>
  )
}

const LandingSliderSection = (props) => {
  return (
    <MultiLayerBimboArt />
  )
};

export default LandingSliderSection;
